import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from '../Components/Loading';
import styles from '../Styles/DynamicModal.module.css';

const AddSiteMainPhotos = ({ closeModal, onSuccess }) => {
  const { openTimeModal } = useTimeModal();
  const [status, setStatus] = React.useState('');
  const [photos, setPhotos] = React.useState([]);

  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files);
    setPhotos((prev) => {
        const combined = [...prev, ...files];
        if (combined.length > 10) {
            openTimeModal('Можно загрузить не более 10 фотографий', 'warning');
            return combined.slice(0, 10);
        }
        return combined;
    });
    e.target.value = null;
  };


  const addNewRoom = (e) => {
    e.preventDefault();
    const formData = new FormData();
    photos.forEach((photo) => formData.append('photos', photo));

    axios
      .post('/api/add-site-main-photos', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(() => {
        setStatus('Фотографии успешно добавлены');
        onSuccess();
        closeModal();
      })
      .catch((error) => {
        setStatus(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
      });
  };

  return (
    <div className={styles.liningOver}>
      <form className={styles.lining} onSubmit={(e) => addNewRoom(e)} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h1>Добавьте фотографии главной страницы сайта</h1>
          </div>
          <svg onClick={() => { closeModal(); }} viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.68342 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000" />
          </svg>
        </div>
        <div className={styles.main}>
          <a>Загрузите фотографии:</a>
          <div className={styles.fileAddPanel}>
            <input 
              type="file" 
              multiple 
              onChange={handlePhotoUpload} 
              accept="image/*" 
            />
          </div>
          {photos.length > 0 &&
          <div style={{width: '100%', padding: '10px', boxSizing: 'border-box', borderRadius: '4px', boxShadow: '0 0 0 1px #e5e5e5', marginBottom: '20px'}}>
            {photos.map((photo, index) => (
              <a key={index} style={{ marginLeft: '10px' }}>
                {photo.name}
              </a>
            ))}
          </div>}
          {status && <a className={styles.statusPanel}><img src="/img/icons/warning-icon.svg" alt="Предупреждение" />{status}</a>}
          <button className="button maxWidth black">Добавить</button>
        </div>
      </form>
    </div>
  );
};

export default AddSiteMainPhotos;

